/*
  EcomHub Pro - subscription widget.

  Kept in an asset rather than inline: a <script> written into a section is lost
  when Dawn re-renders that section's HTML, because scripts inserted through
  innerHTML never execute.

  The form control is the source of truth, not the click that reached it. An
  earlier version tracked selection from clicks on the card, which meant a click
  that arrived by another route (the label forwarding to its input, a keyboard
  press, or Dawn re-rendering the section) could leave nothing selected.
*/
(function () {
  function planFor(opt) {
    if (!opt) return '';
    var freq = opt.querySelector('[data-sub-freq]');
    if (freq && freq.value) return freq.value;
    return opt.getAttribute('data-sub-plan') || '';
  }

  function sync(root) {
    var field = root.querySelector('[data-sub-input]');
    if (!field) return;

    if (root.getAttribute('data-sub-style') === 'checkbox') {
      var box = root.querySelector('[data-sub-check]');
      var card = root.querySelector('[data-sub-opt]');
      var on = !!box && box.checked;
      if (card) card.classList.toggle('is-on', on);
      field.value = on ? planFor(card) : '';
      return;
    }

    var chosen = null;
    var radios = root.querySelectorAll('[data-sub-radio]');
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].checked) {
        chosen = radios[i].closest('[data-sub-opt]');
        break;
      }
    }
    // nothing checked means the markup was replaced under us - fall back to the
    // first option so the widget can never end up with no selection at all
    if (!chosen && radios.length) {
      radios[0].checked = true;
      chosen = radios[0].closest('[data-sub-opt]');
    }
    var all = root.querySelectorAll('[data-sub-opt]');
    for (var k = 0; k < all.length; k++) {
      all[k].classList.toggle('is-on', all[k] === chosen);
    }
    field.value = planFor(chosen);
  }

  function init(root) {
    if (root.dataset.subReady === '1') {
      sync(root);
      return;
    }
    root.dataset.subReady = '1';

    // one delegated listener, so controls added by a re-render still work
    root.addEventListener('change', function (e) {
      var t = e.target;
      if (!t) return;
      if (t.hasAttribute('data-sub-freq')) {
        var opt = t.closest('[data-sub-opt]');
        var radio = opt ? opt.querySelector('[data-sub-radio]') : null;
        if (radio) radio.checked = true;
        var o = t.options[t.selectedIndex];
        var out = opt ? opt.querySelector('[data-sub-price]') : null;
        var m = o && o.getAttribute('data-sub-money');
        if (out && m) out.textContent = m;
      }
      sync(root);
    });

    root.addEventListener('click', function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('[data-sub-freq]')) return;
      // the tooltip lives inside the option label - clicking it must not change
      // the customer's selection
      if (t && t.closest && t.closest('.ehpsub__tipwrap')) {
        e.preventDefault();
        return;
      }
      // let the control itself handle its own click, then read the result
      setTimeout(function () { sync(root); }, 0);
    });

    sync(root);
  }

  function boot() {
    var list = document.querySelectorAll('[data-ehp-sub]');
    for (var i = 0; i < list.length; i++) init(list[i]);
  }

  window.ehpSubBoot = boot;
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('DOMContentLoaded', boot);

  if (window.MutationObserver) {
    new MutationObserver(function () { boot(); }).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  boot();
})();
